// Order Now + required personalization (engraving name / photo upload).
//
// The personalization box stays exactly where it is on the page (above Order Now).
// Its values are mirrored into hidden inputs inside Craft's real add-to-cart form, so both the
// native Add to Cart button and our Order Now button send the engraving/photo along.
// (Nothing here relies on the form="..." attribute, which Shopify strips from custom_liquid content.)
(function () {
  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var MAX_PHOTO_BYTES = 10 * 1024 * 1024; // 10 MB

  function getForm() {
    return document.querySelector(FORM_SELECTOR);
  }

  // Copy every personalization field into a hidden twin inside the real form.
  function syncMirrors() {
    var form = getForm();
    if (!form) return;
    form.querySelectorAll('[data-cc-mirror]').forEach(function (el) { el.remove(); });

    document.querySelectorAll('.cc-personalize-input').forEach(function (src) {
      if (!src.name) return;
      var mirror = document.createElement('input');
      mirror.setAttribute('data-cc-mirror', '1');
      mirror.name = src.name;
      mirror.style.display = 'none';
      if (src.type === 'file') {
        mirror.type = 'file';
        if (src.files && src.files.length) {
          try { mirror.files = src.files; } catch (err) { /* older browsers */ }
        }
      } else {
        mirror.type = 'hidden';
        mirror.value = src.value;
      }
      form.appendChild(mirror);
    });
  }

  // Returns { field, message } for the first problem found, or null if everything is fine.
  function findProblem() {
    var required = document.querySelectorAll('.cc-personalize-input[required]');
    for (var i = 0; i < required.length; i++) {
      var f = required[i];
      if (f.type === 'file') {
        if (!f.files || f.files.length === 0) {
          return { field: f, message: 'Please upload your photo before you can place your order.' };
        }
        var file = f.files[0];
        if (file.type && file.type.indexOf('image/') !== 0) {
          return { field: f, message: 'Please choose an image file (JPG or PNG).' };
        }
        if (file.size > MAX_PHOTO_BYTES) {
          return { field: f, message: 'This photo is too large. Please choose one under 10 MB.' };
        }
      } else if (!f.value.trim()) {
        return { field: f, message: 'Please enter the engraving name before you can place your order.' };
      }
    }
    return null;
  }

  function showWarning(problem) {
    var field = problem.field;
    field.classList.add('cc-field-error');
    field.focus();
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var block = field.closest('.cc-personalize-block');
    if (!block) return;
    var msg = block.querySelector('.cc-field-warning');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-field-warning';
      block.appendChild(msg);
    }
    msg.textContent = problem.message;
    msg.style.display = 'block';

    var clearWarning = function () {
      msg.style.display = 'none';
      field.classList.remove('cc-field-error');
      field.removeEventListener('input', clearWarning);
      field.removeEventListener('change', clearWarning);
    };
    field.addEventListener('input', clearWarning);
    field.addEventListener('change', clearWarning);
  }

  function showButtonError(btn, text) {
    var wrap = btn.closest('.cc-cta-block');
    if (!wrap) return;
    var msg = wrap.querySelector('.cc-cta-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-cta-error';
      msg.style.cssText = 'color:#8C1F2B;font-size:12px;font-weight:700;margin:0;padding:8px 10px;background:#FBEAEA;border-left:3px solid #8C1F2B;';
      wrap.insertBefore(msg, btn.nextSibling);
    }
    msg.textContent = text;
    msg.style.display = 'block';
  }

  // Keep the hidden twins up to date whenever the customer types or picks a file.
  ['input', 'change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('cc-personalize-input')) {
        syncMirrors();
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMirrors);
  } else {
    syncMirrors();
  }

  // Native Add to Cart: block it when a required field is empty (Craft's form has novalidate).
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var problem = findProblem();
      if (problem) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showWarning(problem);
        return;
      }
      syncMirrors();
    },
    true
  );

  // Order Now button.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-btn-primary');
    if (!btn) return;
    e.preventDefault();

    var problem = findProblem();
    if (problem) { showWarning(problem); return; }

    var form = getForm();
    if (!form) { showButtonError(btn, 'Could not find the order form. Please refresh and try again.'); return; }

    syncMirrors();

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';

    var formData = new FormData(form);
    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(cartAddUrl, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) {
            throw new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
          });
        }
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = originalText;
        showButtonError(btn, err && err.message ? err.message : 'Something went wrong. Please try again or use Add to Cart below.');
      });
  });
})();
